import { render, staticRenderFns } from "./AiMatches.vue?vue&type=template&id=4de9edd0&scoped=true&"
import script from "./AiMatches.vue?vue&type=script&lang=js&"
export * from "./AiMatches.vue?vue&type=script&lang=js&"
import style0 from "./AiMatches.vue?vue&type=style&index=0&id=4de9edd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de9edd0",
  null
  
)

export default component.exports